import { Box, Typography } from '@mui/material';
import { style } from './style';

type ContactInfoStatusProps = {
  icon: JSX.Element,
  color: string,
  description: string,
  variant: 'body2' | 'caption',
}

export const ContactInfoStatus = ({
  icon,
  color,
  description,
  variant,
}: ContactInfoStatusProps):JSX.Element => {
  return (
    <Box sx={ style.Box.sx(color) }>
      {icon}
      <Typography variant={ variant } sx={ style.Typography.sx }>
        {description}
      </Typography>
    </Box>
  );
};
